module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-row",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticClass: "timeline-icon",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.iconClicked($event)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-flat bg-grey-100 timeline-content",
    attrs: {
      "id": "newItemBlock"
    }
  }, [_c('div', {
    staticClass: "panel-body text-center text-grey-400 text-size-large"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.proccessAdd($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    class: {
      'bg-primary': _vm.isActive
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    class: {
      'bg-primary-300': _vm.isActive, 'bg-grey-100': !_vm.isActive
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter new link"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "focus": _vm.toggle,
      "blur": _vm.toggle,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }, _vm.urlChanged]
    }
  }), _vm._v(" "), (_vm.url != '') ? _c('span', {
    staticClass: "input-group-addon",
    class: {
      'bg-primary': _vm.isActive && _vm.isPublic, 'bg-danger': _vm.isActive && !_vm.isPublic
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePublic($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.modeTitle))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    class: {
      'bg-primary': _vm.isActive
    },
    on: {
      "click": _vm.proccessAdd
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), (_vm.type) ? _c('note-item', {
    attrs: {
      "item": {
        owner: _vm.owner,
        title: _vm.title,
        content: _vm.content,
        image: _vm.image,
        description: _vm.description,
        type: _vm.type
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-primary-300"
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61e1863e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewItem.vue
// module id = 361
// module chunks = 0